/**
 * /usecases/consolidate-providers — a PAGE. AppLayoutRoute supplies the chrome.
 * Content lives in ../data/cases.ts; the template renders it.
 */
import { UseCaseTemplate } from '../components/UseCaseTemplate';

export default function ConsolidateProvidersPage() {
  return <UseCaseTemplate slug="consolidate-providers" />;
}
